import { FC } from 'react';
// mui components
import { Grid, Box, DialogContent } from '@mui/material';
// components
import { Dialog } from '@mui/material';
import { Content } from './content';
// icons
import CloseIcon from 'assets/icons/file-modal-close.svg';
// styles
import { styles } from './styles';
import { FileActivityFeed } from 'widgets/side-panel/sections/file-activity-feed/FileActivityFeed';
import { Header } from './header';
import { IProject } from 'redux-store/api/projects';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';

export interface IProps {
  open: boolean;
  url: string;
  path?: string;
  mimeType: string;
  name?: string;
  size?: string;
  handleClose: () => void;
  fileId?: string | number;
  project?: IProject;
}

const FileViewerModal: FC<IProps> = ({
  open,
  size,
  path,
  name,
  handleClose,
  fileId,
  project,
  ...contentProps
}) => {
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();

  const isActivityFeedVisible =
    userPermissions?.ENABLE_ACTIVITY_FEED?.canCreate &&
    userPermissions?.ENABLE_FILE_ACTIVITY_FEED?.canCreate;

  return (
    // <Dialog open={open} sx={styles.modal} onClose={handleClose}>
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          ...styles.dialogPaper,
        },
      }}
    >
      <DialogContent sx={styles.dialogContent}>
        <Grid container sx={{ height: '100%' }}>
          <Grid
            item
            xs={true}
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              minWidth: 0,
              position: 'relative',
            }}
          >
            <Box sx={styles.modalCloseButton} onClick={handleClose}>
              <CloseIcon />
            </Box>
            <Header path={path} mimeType={contentProps.mimeType} name={name} size={size} />
            <Box
              sx={{
                flex: 1,
                overflow: 'auto',
                minHeight: 0,
              }}
            >
              <Content {...contentProps} />
            </Box>
          </Grid>
          {fileId && project && isActivityFeedVisible ? (
            <Grid item xs={'auto'} sx={{ height: '100%' }}>
              <Box
                sx={{
                  width: '448px',
                  height: '100%',
                  overflow: 'hidden',
                  paddingLeft: 2,
                  flexShrink: 0,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <FileActivityFeed
                  fileId={fileId.toString()}
                  fileName={name || ''}
                  project={project}
                  onClose={handleClose}
                />
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default FileViewerModal;
